<template>
  <div>
    <div class="ts-flex ts-space-x-3 ts-items-center ts-mt-6">
      <h2 class="ts-text-gray-500 ts-text-base ts-capitalize ts-mb-0">
        <i class="fas fa-wrench ts-mr-3"></i>
        {{ $t('serviceRequest.borrowingSparePart') }}
      </h2>
    </div>
    <div class="ts-h-2"></div>
    <h2 class="ts-text-gray-800 ts-text-base">
      <span>
        {{ $t('serviceRequest.borrowingNumber') }} :
        {{ borrowingSparePart.sfo_number }}
      </span>
    </h2>
    <table class="ts-w-full">
      <tbody>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.borrowingDate') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              borrowingSparePart.service_date
                ? borrowingSparePart.service_date
                : '-'
            }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.serviceType') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              borrowingSparePart.service_type
                ? borrowingSparePart.service_type
                : '-'
            }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.requestBy') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              borrowingSparePart.requested_by_name
                ? borrowingSparePart.requested_by_name
                : '-'
            }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.deliveredBy') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              borrowingSparePart.delivered_by_name
                ? borrowingSparePart.delivered_by_name
                : '-'
            }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.verifiedBy') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              borrowingSparePart.verified_by_name
                ? borrowingSparePart.verified_by_name
                : '-'
            }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.receivedBy') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              borrowingSparePart.received_by_name
                ? borrowingSparePart.received_by_name
                : '-'
            }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.plateNumber') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              borrowingSparePart.plate_number
                ? borrowingSparePart.plate_number
                : '-'
            }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.borrowingRef') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              borrowingSparePart.borrowing_ref
                ? borrowingSparePart.borrowing_ref
                : '-'
            }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="ts-h-2"></div>
    <div class="overflow-auto ts-max-h-40">
      <div class="table-ui-detail">
        <table>
          <thead>
            <tr>
              <th width="2%" class="ts-text-center">
                {{ $t('no') }}
              </th>
              <th>
                {{ $t('serviceRequest.barcode') }}
              </th>
              <th>
                {{ $t('serviceRequest.product') }}
              </th>
              <th class="text-center">
                {{ $t('serviceRequest.uom') }}
              </th>
              <th class="text-center" width="7%">
                {{ $t('serviceRequest.quantityOrder') }}
              </th>
              <th class="text-center" width="7%">
                {{ $t('serviceRequest.quantityReturn') }}
              </th>
              <th class="text-center" width="10%">
                {{ $t('serviceRequest.unitPrice') }}
              </th>
              <th class="text-center" width="5%">
                {{ $t('serviceRequest.cusR') }}
              </th>
              <th class="text-center" width="7%">
                {{ $t('serviceRequest.cusR%') }}
              </th>
              <th class="text-center" width="10%">
                {{ $t('serviceRequest.amount') }}
              </th>
              <th class="text-center" width="5%">
                {{ $t('serviceRequest.vendorRes') }}
              </th>
              <th class="text-center" width="7%">
                {{ $t('serviceRequest.vendor%') }}
              </th>
              <th class="text-center" width="10%">
                {{ $t('serviceRequest.amount') }}
              </th>
            </tr>
          </thead>
          <tbody v-if="borrowingSparePart.details">
            <tr
              v-for="(detail, index) in borrowingSparePart.details"
              :key="index"
            >
              <td class="ts-whitespace-nowrap ts-text-center">
                {{ index + 1 }}
              </td>
              <td class="ts-whitespace-nowrap">
                {{ detail.barcode }}
              </td>
              <td class="ts-whitespace-nowrap">
                {{ detail.product_name_en }}
              </td>
              <td class="ts-whitespace-nowrap ts-text-center">
                {{ detail.uom_name_en }}
              </td>
              <td class="ts-whitespace-nowrap ts-text-center">
                {{ detail.quantity_order }}
              </td>
              <td class="ts-whitespace-nowrap ts-text-center">
                {{ detail.quantity_return }}
              </td>
              <td class="ts-whitespace-nowrap ts-text-center">
                <ts-currency-input
                  v-model.number="detail.sale_price"
                  class="form-control ts-text-right"
                  :disabled="true"
                  style="min-width: 100px; height:25px;"
                  :currency="default_currency_sign"
                  :precision="default_precision"
                />
              </td>
              <td class="ts-whitespace-nowrap ts-text-center">
                <input checked="true" type="checkbox" disabled />
              </td>
              <td class="ts-whitespace-nowrap ts-text-center">
                <input
                  v-model.number="detail.customer_cover_percentage"
                  type="number"
                  :min="0"
                  :max="100"
                  :readonly="true"
                  style="height:25px;"
                  class="form-control ts-text-center"
                />
              </td>
              <td class="ts-whitespace-nowrap ts-text-right">
                <ts-currency-input
                  :value="customerAmount(detail)"
                  class="form-control ts-text-right"
                  style="min-width: 100px;height:25px;"
                  :currency="default_currency_sign"
                  :precision="default_precision"
                  :disabled="true"
                />
              </td>
              <td class="ts-whitespace-nowrap ts-text-center">
                <input
                  v-model="detail.is_vendor_cover"
                  type="checkbox"
                  disabled
                />
              </td>
              <td class="ts-whitespace-nowrap ts-text-center">
                <input
                  v-model.number="detail.vendor_cover_percentage"
                  type="number"
                  :min="0"
                  :max="100"
                  :readonly="true"
                  style="height:25px;"
                  class="form-control ts-text-center"
                />
              </td>
              <td class="ts-whitespace-nowrap ts-text-right">
                <ts-currency-input
                  :vendorAmount="vendorAmount(detail)"
                  class="form-control ts-text-right"
                  style="min-width: 100px;height:25px;"
                  :currency="default_currency_sign"
                  :precision="default_precision"
                  :disabled="true"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['borrowingSparePart'],
  data() {
    return {
      loading: true
    }
  },
  computed: {
    default_currency_sign() {
      return this.$store.state.authUser.sys_setting.default_currency_sign
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    }
  },
  methods: {
    customerAmount(detail) {
      //customer_amount
      return detail.quantity_sold
        ? _.round(
            detail.sale_price *
              detail.quantity_sold *
              (detail.customer_cover_percentage / 100),
            this.default_precision
          )
        : 0
    },
    vendorAmount(detail) {
      //vendor_amount
      return detail.quantity_sold
        ? _.round(
            detail.sale_price *
              detail.quantity_sold *
              (detail.vendor_cover_percentage / 100),
            this.default_precision
          )
        : 0
    }
  }
}
</script>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
</style>
